import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import { AppStateContext } from '../AppStateContext';

import Whatsapp from '../media/WhatsApp.svg'

// IMPORT VIDEO
import testimonialVideo1 from '../media/testimonial-video-1.mp4'
import testimonialVideo2 from '../media/testimonial-video-2.mp4'

import yesimalkan_image from '../media/yesimalkan-2.webp'
import TreatmentSlider from '../components/TreatmentSlider'

const About = () => {
    const navigate = useNavigate();
    const { language, setLanguage } = useContext(AppStateContext);

    // PAGE TITLE
    const pageTitle = 'DT. Yesim Alkan | Hakkında'
    const metaDescription = 'DT. Yeşim Alkan hakkında bilgi ve diş tedavisi hizmetleri. İletişim için bize ulaşın.'

    const translations = {
        tr: {
            banner1text1: '',
            banner1text2: "Yeşim Alkan, İstanbul, Türkiye'de diş tedavisi aramak için ücretsiz bir platform sunmaktadır. Platformumuz yalnızca İstanbul'daki diş tedavisi aramalarına odaklanmış olup, bireylerin doğru kozmetik klinikleri ve uzman plastik cerrahları İstanbul'da bulmalarına, karşılaştırmalarına ve randevu almalarına yardımcı olmayı amaçlar.",
            banner1text3: "İstanbul'da yüksek kaliteli diş tedavisi prosedürleri için kullanıcı dostu bir arama platformu sağlamak en öncelikli hedefimizdir. Tüm prosedürler, İstanbul'da bulunan en iyi kozmetik ve plastik cerrahlar tarafından gerçekleştirilir ve birinci sınıf özel tesislerde yapılır.",
            banner1text4: 'Tedaviler',
            banner2text1: 'Bizi Tanıyın',
            banner2text2: 'İstanbul doğumlu olan DT. Yeşim Alkan 1987 yılında Kadıköy Anadolu Lisesinden mezun olduktan sonra 1992 yılında İstanbul Üniversitesi Diş Hekimliği Fakültesinden başarıyla mezun olmuştur. O günden beri çeşitli eğitim, kongre ve seminerlere katılmıştır. 1992 yılından beri Bağdat Caddesindeki Özel muayenehanesinde başta estetik diş hekimliği, implantoloji ve cerrahi olmak üzere tüm diş hekimliği dallarında hastalarına hizmet vermektedir.',
            banner2text3: 'Randevularınızdan tam gülümsemenize kadar ihtiyaçlarınızı karşılarken sizlere konforlu ve rahat bir ortamda, sıcak ve kişisel bir yaklaşımla uzman diş bakımı sağlanmaktadır. Ağız sağlığınızı karşılamak için geniş bir diş tedavisi yelpazesi sunmaktayız.',
            banner2text4: 'İletişim',
        },
        en: {
            banner1text1: '',
            banner1text2: "Yeşim Alkan offers a free platform for searching dental treatments in Istanbul, Turkey. Our platform is focused solely on dental treatment searches in Istanbul, aiming to assist individuals in finding, comparing, and booking appointments with the right cosmetic clinics and expert plastic surgeons in Istanbul.",
            banner1text3: "Our primary goal is to provide a user-friendly search platform for high-quality dental treatment procedures in Istanbul. All procedures are performed by top cosmetic and plastic surgeons in Istanbul and take place in state-of-the-art private facilities.",
            banner1text4: 'Treatments',
            banner2text1: 'About Us',
            banner2text2: 'Born in Istanbul, DT. Yeşim Alkan graduated from Kadıköy Anadolu High School in 1987 and successfully graduated from Istanbul University Faculty of Dentistry in 1992. Since then, she has participated in various training, congresses, and seminars. Since 1992, she has been providing services to patients in various fields of dentistry, including aesthetic dentistry, implantology, and surgery, at her private clinic on Bağdat Street.',
            banner2text3: 'We provide expert dental care with a warm and personal approach in a comfortable and relaxing environment from your appointments to your perfect smile. We offer a wide range of dental treatments to meet your oral health needs.',
            banner2text4: 'Contact',
        },
        it: {
            banner1text1: '',
            banner1text2: "Yeşim Alkan offre una piattaforma gratuita per la ricerca di trattamenti dentali a Istanbul, in Turchia. La nostra piattaforma è focalizzata esclusivamente sulla ricerca di trattamenti dentali a Istanbul, con l'obiettivo di assistere le persone nella ricerca, confronto e prenotazione di appuntamenti presso le cliniche cosmetiche e gli esperti chirurghi plastici giusti a Istanbul.",
            banner1text3: "Il nostro obiettivo principale è fornire una piattaforma di ricerca user-friendly per procedure di trattamento dentale di alta qualità a Istanbul. Tutte le procedure sono eseguite dai migliori chirurghi cosmetici e plastici di Istanbul e si svolgono in strutture private all'avanguardia.",
            banner1text4: 'Trattamenti',
            banner2text1: 'Chi Siamo',
            banner2text2: "Nata a Istanbul, la DT. Yeşim Alkan si è diplomata alla Kadıköy Anadolu High School nel 1987 ed è laureata con successo presso la Facoltà di Odontoiatria dell'Università di Istanbul nel 1992. Da allora ha partecipato a vari corsi di formazione, congressi e seminari. Dal 1992, fornisce servizi ai pazienti in vari settori dell'odontoiatria, tra cui l'odontoiatria estetica, l'implantologia e la chirurgia, presso la sua clinica privata in Bağdat Street.",
            banner2text3: "Forniamo cure odontoiatriche di alta qualità con un approccio personale in un ambiente confortevole e rilassante, dalle vostre visite al vostro sorriso perfetto. Offriamo una vasta gamma di trattamenti dentali per soddisfare le vostre esigenze di salute orale.",
            banner2text4: 'Contatto',
        },
    };

    const getText = (key) => {
        return translations[language][key] // Default to the provided key if translation is not found
    };

    const handleNavigation = (path) => {
        window.scrollTo(0, 0);
        navigate(path);
    }

    const openLink = (url) => {
        window.open(
            url,
            '_blank'
        );
    }
    return (
        <div className='w-full overflow-x-hidden'>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
                <link rel="canonical" href="http://dtyesimalkan.com/about" />
            </Helmet>
            <Navbar />
            <div className='w-full h-[120px]'></div>

            <div className='flex flex-col md:flex-row w-full max-w-screen-xl md:my-20 m-auto gap-5 rounded-xl md:h-[600px]'>
                <div className='w-full md:w-1/2 flex flex-col p-10 m-auto bg-slate-50 md:rounded-xl h-full justify-center'>
                    <div className='text-xl md:text-2xl text-[#6DA5C0]'>{getText('banner2text1')}</div>
                    <div style={{ fontFamily: 'Righteous' }} className='text-4xl md:text-4xl text-[#0F969C] pt-2'>Dt. Yeşim Alkan</div>
                    <div className='pt-5 text-md md:text-lg text-black'>{getText('banner2text2')}</div>
                    <div className='pt-5 text-md md:text-lg text-black'>{getText('banner2text3')}</div>
                </div>

                <div className='w-full md:w-1/2 h-full '>
                    <img src={yesimalkan_image} className='w-full h-96 md:h-full object-contain' ></img>
                </div>
            </div>

            <div className='flex flex-col md:flex-row-reverse w-full max-w-screen-xl md:my-20 m-auto md:gap-5 rounded-xl md:h-[600px]'>
                <div className='w-full md:w-1/2 flex flex-col p-10 m-auto bg-slate-50 md:rounded-xl h-full justify-center'>
                    <div className='text-lg md:text-2xl text-[#6DA5C0]'>{getText('banner1text1')}</div>
                    <div className='pt-5 text-md md:text-lg text-black'>{getText('banner1text2')}</div>
                    <div className='pt-5 text-md md:text-lg text-black'>{getText('banner1text3')}</div>
                </div>
                <div className='w-full md:w-1/2 h-96 md:h-full p-5 md:p-0'>
                    <video autoPlay playsInline loop muted
                        className='rounded-xl'
                        style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                            top: "0",
                            left: "0",
                            zIndex: -1,
                        }}>
                        <source src={testimonialVideo1} type='video/mp4' ></source>
                    </video>
                </div>
            </div>
            <div className='bg-[#05161A]'>
                <TreatmentSlider />
            </div>
            <Footer />
        </div>
    )
}

export default About